import { useQSet } from '@exam-management/common/qset-provider';
import { NavigateBackLink, QSetStatusTag } from '@exam-management/components';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { Divider, PageHeader } from '@shared/components';
import { WithPermission } from '@shared/permissions';

import { MoreActionMenu } from '../more-action-menu';
import { QSetNavigationTabs } from '../qset-navigation-tabs';

export default function QSetDetailsHeader() {
  const { qSet } = useQSet();
  const { id, code, examCourseId, status } = qSet;

  return (
    <PageHeader
      title={`ชุดข้อสอบ: ${code}`}
      linkAdornment={
        <NavigateBackLink
          to='/exam-courses/:courseId/qsets'
          params={{ courseId: examCourseId }}
          label='Back'
        />
      }
      endAdornment={
        <>
          <QSetStatusTag status={status} size='large' />
          <Divider orientation='vertical' flexItem sx={{ width: 'unset' }} />
          <WithPermission
            requiredPermission={[
              APP_PERMISSIONS.EXAM.QSET.VIEW,
              APP_PERMISSIONS.EXAM.QSET.CREATE,
              APP_PERMISSIONS.EXAM.QSET.DELETE,
            ]}
            options={{ operator: 'OR' }}
          >
            <MoreActionMenu qSetId={id} status={status} />
          </WithPermission>
        </>
      }
      tabs={<QSetNavigationTabs status={status} />}
    />
  );
}
